
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Sa a se pwojè
                    <a href="${0}">Folksonomy Engine</a>ki pote li. Pa
                    ezite patisipe oubyen bay fidbak.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Zouti sa a pèmèt ou korije lis engredyan yo. Ou ka ajoute, retire oswa modifye
                lis engredyan yo.
                <br>
                Karaktè sa a <span class="highlight">␣</span> reprezante yon espas.
                <br>
                Karaktè sa a <span class="highlight">↩︎</span> reprezante yon chanjman liy. `,
'hb28f1f2ec1744ee9': html`Itilizatè yo kreye epi klase pwopriyete sa yo pou tout kalite itilizasyon. Ou lib
                    pou ajoute pwòp pa ou. Pwopriyete ak valè ou kreye yo
                    <strong>dwe reyèl</strong>. Ou ka fouye nan
                    <a href="${0}">lis pwopriyete kominote a deja itilize yo</a>
                    oubyen eksplore dokimantasyon pwopriyete yo
                    <a href="${1}">ak motè rechèch li a</a>.`,
's000a5b76bd3a01c2': `Ap chaje pwopriyete yo...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Ede nou pou engredyan yo`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Valide rekòt la`,
's03e9c8114521b998': `M ap modifye engredyan yo`,
's05ec315d9308091a': `Ikòn kwen kòd bar`,
's061eb5af92512c85': `Sove! Èske ou ka ede ak yon lòt?`,
's06847c221c4c0bc1': `Mwen ta renmen kreye yon pwopriyete pou [dekri ka itilizasyon ou an]...`,
's06f6c6f99db6b552': `Orijinal`,
's081e2ad82db71e1d': `Valè Gwoupe`,
's09205907b5b56cda': `Non`,
's0b4235aae602a950': `dokimantasyon dedye`,
's0bb2d48532acc455': `Telechaje CSV a`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Anile imaj la`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Anile rekòt la`,
's11a18a69b30b65ed': `Ede nou korije erè nan lis engredyan yo`,
's1205d5f6fccf8e69': `Valè Pwopriyete`,
's15d64a0a6715285a': `Nouvo kle`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Zòn seleksyon an`,
's1a52515ec8ddade8': `Kòd ba pwodwi`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Ede nou korije enfòmasyon nitrisyonèl yo`,
's1e00019dc454872d': `Tanpri bay yon non pwopriyete avèk atribi property-name la.`,
's1e49126af0935a5b': `Lis pwodwi ki itilize pwopriyete sa a`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Anile`,
's2db7b654c0a9bde0': `Dokimante pwopriyete a`,
's300b3a6ee4e1252d': str`Pòv Match ${0}%`,
's33f786bb6b4f0cf4': `Rezilta rekòt`,
's33f85f24c0f5f008': `Anrejistre`,
's34be4af4e8fec4ae': `Mande kominote a an premye`,
's36d86adc823cbfa6': `Anvan ou kreye yon nouvo pwopriyete, diskite sou li ak kominote a:`,
's3781d25aa51a736c': `Dokimantasyon Motè Folksonomi`,
's383ae4449428b61e': `Reyajiste rekòt la`,
's39bcf88721a1e8ee': `Reyajiste seleksyon an`,
's39e14e14300694c7': `Dokimantasyon ak Gid`,
's3b430cfa5c1fe7f4': str`Dokimantasyon pou ${0}`,
's3f4e4b52f230a892': `Kanva imaj`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Valè`,
's422bba9636ce2489': `Sant imaj la`,
's42dd66b2441566fd': `Ikòn sant lan`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Chanje gwosè adwat`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Chaje...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Kantite pwodwi`,
's4df2f533c0c1e7d0': `Kontwòl imaj`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Deplase seleksyon an`,
's4f751fb9b3ed766c': `Kreye yon nouvo pwopriyete`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Antre non pwopriyete a...`,
's55d7249883a98ca1': `sou pwopriyete sa a sou wiki Open Food Facts la`,
's565867d84c04aea2': `Pwopriyete filtè...`,
's5666afe5cd0166de': `Tanpri korije erè yo oubyen modifye tèks la anvan ou konfime.`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Ap chaje pwodwi yo...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Ede nou korije enfòmasyon nitrisyonèl yo.`,
's5dd6f12783fca34f': `Modifye lis engredyan yo`,
's5e8250fb85d64c23': `Fèmen`,
's5ed03bb1f3a15949': `Foto`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Modifye`,
's66413c24dcf680e2': `Pase`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Imaj koupe`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Bon Match ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Dokimantasyon`,
's787dd11bed0dc88a': `Chanje gwosè a agoch`,
's7ce4fd9430e80cea': `valè`,
's801a05fa8e881f37': `Aprann plis bagay sou kreyasyon pwopriyete ak direktiv yo:`,
's8038273de2cf8b73': `Tanpri chwazi yon rejyon pou koupe.`,
's839cc2908a5387f2': `Filtre kòd bar yo...`,
's86197dcf3e96af64': `Browse epi chèche pwopriyete ki deja egziste yo`,
's8a63be30a129a59c': `Chanje gwosè anba a`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Chanje gwosè anwo adwat`,
's8db84aa4bc949af2': `Dokimante Nouvo Pwopriyete a`,
's8f839a03997a16d7': `Gade pwodwi a`,
's901ae1e236ac45d3': `Anile sipresyon an`,
's907f7a97c6b29425': `Fè atansyon modèl done a ka modifye. Sèvi ak li sou pwòp risk ou.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Engredyan:`,
's9a7f60fce090ecaf': `Pwopriyete yo pa t kapab chaje. Tanpri eseye ankò pita.`,
's9b87abd68fb9df45': `Ou pa jwenn li? Kreye yon nouvo kle {value}`,
's9c0f52425fd2f07e': `Ka pa koresponn`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `Pa gen nòt disponib`,
'sa548778b24054030': `Eksplore tout pwopriyete kontribye nan pwojè Folksonomy Engine la. Pwopriyete sa yo bay plis metadone ak enfòmasyon sou pwodwi ki nan baz done Open Food Facts la.`,
'sa63907958bd0ec4b': `Chanje gwosè anwo agoch`,
'sa95b4224f685a36a': `Fèmen modal la`,
'sab56a1d439576fd6': `Ikòn sijesyon`,
'sac47ea2901d04c15': `Chanje gwosè anba agoch la`,
'sb125227d436c2925': `Chèche konsèp pwopriyete w la nan baz done pwopriyete ki deja egziste a:`,
'sb125568d43642e6f': `Reponn kesyon sou pwodwi a.`,
'sb1c538e038f9b214': str`Trè Bon Match ${0}%`,
'sb28639570ff3b852': `lis tout pwopriyete yo`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Yon fwa ou fin verifye ke pwopriyete w la pa egziste epi kominote a dakò ke li itil, ou bezwen premye dokimante li nan wiki a.`,
'sb3d4f79d9d8b71e5': `Soumèt`,
'sb560fa37a7bfb6c2': `Pa gen okenn pwodwi ki te jwenn pou pwopriyete sa a.`,
'sb7f72e4c8a2d3357': `Filtre valè yo...`,
'sb8178320160f84ea': `Montre rekòt la`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Tout repons yo te jwenn! Mèsi pou èd ou!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Valè Korespondan`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Chanje gwosè anlè a`,
'sc1c08d0cbcc3bd24': `Pa koresponn`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Sijesyon pou ranje`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `Deplase imaj la`,
'sc895972c88d38ca5': `Pwopriyete folksonomi`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Ranje`,
'scb3b0671d7b7f640': `Nouvo valè`,
'scb489a1a173ac3f0': `Wi`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Antre nan yon diskisyon Slack`,
'scdb6cad0b92721bf': `Pa jwenn okenn pwopriyete.`,
'scf23a05631f93732': `Konfime Efase`,
'scfed2f270ef6a3aa': `Chwazi zòn nan`,
'sd1022bc1ef9204f7': `Imaj ou ka agrandi`,
'sd1077c055cf9ba6b': `Ede nou valide lis engredyan ki nan pwodwi a.`,
'sd698d21ddecba56b': `Hey! Ou ka ede nou amelyore enfòmasyon sou pwodwi a lè w reponn pati sa yo:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Tcheke si yon pwopriyete deja egziste`,
'sdbf806fefc584115': `Ou ta dwe jwenn yon`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `Ede nou korije òtograf engredyan yo.`,
'sdca5deead576ceee': `Chanje gwosè anba adwat la`,
'sdcc2555c5dde524f': `Èske ou sèten ou vle efase atik sa a? Ou pa ka anile aksyon sa a.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Anile`,
'se5127cf0f92e7e48': `Konsèy: ou ka jwenn tou`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `M ap pwopoze yon pi bon rekòt`,
'seea3800e27baa686': `Pwodwi Endividyèl yo`,
'sefaba4adc4ec9219': `Pwopriyete Folksonomi`,
'seffa8ca49175b5f0': `Pwopriyete pèsonalize`,
'sf44a6b3b232c28ea': str`Ranplase valè aktyèl la pa ${0}`,
'sf4cd86a2f5ef2588': `Kòd Bar Pwodwi`,
'sf57a61152168cc81': `Ede nou korije deteksyon engredyan an`,
'sf88b90b8ba23871c': `Matche ak enkoni`,
'sf9aee319a006c9b4': `Add`,
'sfacbbe968fa7d773': `Non pwopriyete a:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Valè korespondan`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  